import { HierarchicalMenu } from "react-instantsearch";
import React from "react";
import "./CustomCategories.scss";
import Accordion from "../../../UI/Accordion/Accordion";

const Categories = (props) => {
    const { panelTitle, categories } = props;

    return (
        <div>
            <Accordion header={panelTitle}>
                <div className="search-filter__categories">
                    <HierarchicalMenu attributes={categories} />
                </div>
            </Accordion>
        </div>
    );
};

export default Categories;
